import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { tID } from '../../utils/utils'
import { TextModal } from '../textModal/TextModal'

export type EndSessionModalProps = {
  show: boolean
  onClose: () => void
  onConfirm: () => void
}

export const EndSessionModal: FunctionComponent<EndSessionModalProps> = ({ show, onClose, onConfirm }) => {
  const { formatMessage } = useIntl()

  return (
    <TextModal
      isOpen={show}
      onClose={onClose}
      title={formatMessage({
        defaultMessage: 'Are you sure you want to end the session?',
        description: 'Title of modal where provider may end the session',
      })}
      description={
        <FormattedMessage
          defaultMessage='If you end this session, you will not be able to rejoin. If you are experiencing technical difficulties, try
                  refreshing the page and then rejoining.'
          description='Content of modal where provider may end the session'
        />
      }
      primaryCTA={onConfirm}
      secondaryCTA={onClose}
      textAlignment='left'
      snapPoints={[480]}
      primaryButtonText={<FormattedMessage defaultMessage='End Session' description='Button text that ends sessions' />}
      primaryButtonTestID={tID('EndSessionModal-confirm-button')}
      secondaryButtonText={
        <FormattedMessage
          defaultMessage='Cancel'
          description='Button text that describes exiting confirm dialog without ending session'
        />
      }
      secondaryButtonTestID={tID('EndSessionModal-cancel-button')}
      testID={tID('EndSessionModal')}
    />
  )
}
